// // SecureContent.jsx - Affiche du contenu HTML avec vidéos protégées
// import React, { useEffect, useRef } from 'react';
// import Plyr from 'plyr';
// import 'plyr/dist/plyr.css';
// import API_BASE from '../config/apiConfig';

// /**
//  * Composant qui affiche du contenu HTML et transforme automatiquement
//  * toutes les balises <video> en lecteurs Plyr sécurisés (sans téléchargement)
//  */
// const SecureContent = ({ html, className = '', style = {} }) => {
//     const containerRef = useRef(null);
//     const playersRef = useRef([]);

//     /**
//      * Transforme les URLs localhost et relatives en URLs du backend
//      */
//     const transformUrls = (content) => {
//         if (!content || typeof content !== 'string') return content;
        
//         return content
//             // Remplacer localhost
//             .replace(/http:\/\/localhost:3000\/api\//g, `${API_BASE}/`)
//             .replace(/https:\/\/localhost:3000\/api\//g, `${API_BASE}/`)
//             .replace(/http:\/\/localhost:8080\/api\//g, `${API_BASE}/`)
//             .replace(/https:\/\/localhost:8080\/api\//g, `${API_BASE}/`)
//             // Remplacer les URLs relatives
//             .replace(/src="\/api\//g, `src="${API_BASE}/`)
//             .replace(/src='\/api\//g, `src='${API_BASE}/`)
//             .replace(/href="\/api\//g, `href="${API_BASE}/`)
//             .replace(/href='\/api\//g, `href='${API_BASE}/`);
//     };

//     useEffect(() => {
//         if (!containerRef.current) return;

//         // Détruire les anciens players
//         playersRef.current.forEach(player => {
//             try {
//                 player.destroy();
//             } catch (e) {
//                 console.warn('Erreur destruction player:', e);
//             }
//         });
//         playersRef.current = [];

//         // Trouver toutes les vidéos dans le conteneur
//         const videos = containerRef.current.querySelectorAll('video');
        
//         videos.forEach((video, index) => {
//             // Ajouter les attributs de sécurité
//             video.setAttribute('playsinline', '');
//             video.setAttribute('disablePictureInPicture', '');
//             video.removeAttribute('controlsList'); // Plyr gère les contrôles
            
//             // Bloquer le clic droit sur la vidéo
//             video.addEventListener('contextmenu', (e) => {
//                 e.preventDefault();
//                 return false;
//             });

//             // Initialiser Plyr
//             try {
//                 const player = new Plyr(video, {
//                     controls: [
//                         'play-large',
//                         'play',
//                         'progress',
//                         'current-time',
//                         'duration',
//                         'mute',
//                         'volume',
//                         'settings',
//                         'fullscreen'
//                         // PAS de 'download' !
//                     ],
//                     settings: ['speed'],
//                     speed: { selected: 1, options: [0.5, 0.75, 1, 1.25, 1.5, 2] },
//                     keyboard: { focused: true, global: false },
//                     tooltips: { controls: true, seek: true },
//                     disableContextMenu: true,
//                     hideControls: true,
//                     clickToPlay: true,
//                     autopause: true,
//                 });

//                 playersRef.current.push(player);
//             } catch (e) {
//                 console.warn('Erreur initialisation Plyr:', e);
//             }
//         });

//         // Cleanup
//         return () => {
//             playersRef.current.forEach(player => {
//                 try {
//                     player.destroy();
//                 } catch (e) {}
//             });
//             playersRef.current = [];
//         };
//     }, [html]);

//     // Bloquer le clic droit sur tout le conteneur
//     const handleContextMenu = (e) => {
//         // Autoriser le clic droit sauf sur les vidéos
//         if (e.target.tagName === 'VIDEO' || e.target.closest('.plyr')) {
//             e.preventDefault();
//             return false;
//         }
//     };

//     const transformedHtml = transformUrls(html);

//     return (
//         <>
//             <div
//                 ref={containerRef}
//                 className={`secure-content ${className}`}
//                 style={style}
//                 onContextMenu={handleContextMenu}
//                 dangerouslySetInnerHTML={{ __html: transformedHtml }}
//             />
            
//             {/* Styles Plyr personnalisés */}
//             <style>{`
//                 /* Style Plyr */
//                 .secure-content .plyr {
//                     --plyr-color-main: #667eea;
//                     --plyr-video-control-color: #fff;
//                     --plyr-video-control-color-hover: #fff;
//                     border-radius: 10px;
//                     overflow: hidden;
//                 }
                
//                 .secure-content .plyr__control--overlaid {
//                     background: rgba(102, 126, 234, 0.8) !important;
//                 }
                
//                 .secure-content .plyr__control--overlaid:hover {
//                     background: #667eea !important;
//                 }
                
//                 .secure-content .plyr--video .plyr__controls {
//                     background: linear-gradient(transparent, rgba(0,0,0,0.75)) !important;
//                     padding: 10px;
//                 }
                
//                 /* Cacher le bouton télécharger */
//                 .secure-content [data-plyr="download"],
//                 .secure-content .plyr__controls__item[data-plyr="download"],
//                 .secure-content .plyr__control[data-plyr="download"] {
//                     display: none !important;
//                 }
                
//                 /* Cacher PiP */
//                 .secure-content [data-plyr="pip"],
//                 .secure-content .plyr__control[data-plyr="pip"] {
//                     display: none !important;
//                 }
                
//                 /* Désactiver la sélection sur les vidéos */
//                 .secure-content video,
//                 .secure-content .plyr {
//                     -webkit-user-select: none !important;
//                     -moz-user-select: none !important;
//                     -ms-user-select: none !important;
//                     user-select: none !important;
//                     -webkit-touch-callout: none !important;
//                 }
                
//                 /* Style vidéo */
//                 .secure-content video {
//                     max-width: 100%;
//                     border-radius: 10px;
//                     background: #000;
//                 }
                
//                 .secure-content .video-container,
//                 .secure-content .video-wrapper {
//                     margin: 15px 0;
//                 }
                
//                 /* Cacher contrôles natifs si Plyr échoue */
//                 .secure-content video::-webkit-media-controls-download-button,
//                 .secure-content video::-internal-media-controls-download-button {
//                     display: none !important;
//                 }
//             `}</style>
//         </>
//     );
// };

// export default SecureContent;


// SecureContent.jsx - Lecteur vidéo natif (comme dans l'éditeur modification)
import React, { useEffect, useRef } from 'react';
import API_BASE from '../config/apiConfig';

const SecureContent = ({ html, className = '', style = {} }) => {
    const containerRef = useRef(null);

    const transformUrls = (content) => {
        if (!content || typeof content !== 'string') return content;
        return content
            .replace(/http:\/\/localhost:3000\/api\//g, `${API_BASE}/`)
            .replace(/https:\/\/localhost:3000\/api\//g, `${API_BASE}/`)
            .replace(/http:\/\/localhost:8080\/api\//g, `${API_BASE}/`)
            .replace(/https:\/\/localhost:8080\/api\//g, `${API_BASE}/`)
            .replace(/src="\/api\//g, `src="${API_BASE}/`)
            .replace(/src='\/api\//g, `src='${API_BASE}/`)
            .replace(/href="\/api\//g, `href="${API_BASE}/`)
            .replace(/href='\/api\//g, `href='${API_BASE}/`);
    };

    useEffect(() => {
        if (!containerRef.current) return;

        const videos = containerRef.current.querySelectorAll('video');

        videos.forEach((video) => {
            // ✅ Seulement nodownload — PAS nofullscreen
            video.setAttribute('controlsList', 'nodownload noremoteplayback');
            video.setAttribute('controls', '');
            video.setAttribute('playsinline', '');

            // Bloquer clic droit
            video.addEventListener('contextmenu', (e) => {
                e.preventDefault();
                return false;
            });
        });

    }, [html]);

    const handleContextMenu = (e) => {
        if (e.target.tagName === 'VIDEO') {
            e.preventDefault();
            return false;
        }
    };

    const transformedHtml = transformUrls(html);

    return (
        <>
            <div
                ref={containerRef}
                className={`secure-content ${className}`}
                style={style}
                onContextMenu={handleContextMenu}
                dangerouslySetInnerHTML={{ __html: transformedHtml }}
            />

            <style>{`
                /* ===== STYLE VIDÉO NATIF ===== */
                .secure-content video {
                    max-width: 100%;
                    width: 100%;
                    border-radius: 8px;
                    background: #000;
                    display: block;
                    margin: 10px auto;
                }

                .secure-content .video-container,
                .secure-content .video-wrapper {
                    margin: 15px 0;
                }

                /* Désactiver sélection */
                .secure-content video {
                    -webkit-user-select: none !important;
                    -moz-user-select: none !important;
                    user-select: none !important;
                    -webkit-touch-callout: none !important;
                    -webkit-user-drag: none !important;
                }

                /* Cacher bouton download natif */
                .secure-content video::-webkit-media-controls-download-button,
                .secure-content video::-internal-media-controls-download-button {
                    display: none !important;
                }

                /* ✅ FULLSCREEN NATIF — fonctionne parfaitement */
                .secure-content video:-webkit-full-screen {
                    width: 100vw !important;
                    height: 100vh !important;
                    border-radius: 0 !important;
                    object-fit: contain !important;
                    background: #000 !important;
                }
                .secure-content video:fullscreen {
                    width: 100vw !important;
                    height: 100vh !important;
                    border-radius: 0 !important;
                    object-fit: contain !important;
                    background: #000 !important;
                }
            `}</style>
        </>
    );
};

export default SecureContent;
